import { ThematicPackage, ThematicPackageSite } from '@features/campaigns/shared/types/thematicPackage.ts';

export interface ReferenceSites {
  primary?: ThematicPackageSite;
  secondary: ThematicPackageSite[];
}

function hasNameOrLogo(site?: ThematicPackageSite): boolean {
  return Boolean(site?.name?.trim() || site?.logoUrl?.trim());
}

export function getReferenceSites(sites: ThematicPackage['sites']): ReferenceSites | undefined {
  const primary = hasNameOrLogo(sites?.primary) ? sites.primary : undefined;
  const secondary = (sites?.secondary ?? []).filter(hasNameOrLogo);

  if (!primary && !secondary.length) {
    return undefined;
  }

  return { primary, secondary };
}
